import { Role } from 'types/api';

const numericRoleMap: Record<number, Role> = {
  0: Role.ORGANIZATION_MEMBER,
  1: Role.ORGANIZATION_STAFF,
  2: Role.ORGANIZATION_ADMIN,
  4: Role.SUPER_ADMIN,
};

export const roleDisplayName = (role: Role | number | undefined): string | undefined => {
  if (role === undefined || role === null) return undefined;
  const roleStr =
    typeof role === 'number' ? numericRoleMap[role] : role;
  if (!roleStr) return undefined;
  return roleStr.replace('Organization', '');
};
